/**
 * Section Component
 * Reusable section container for landing page with consistent spacing and background options
 */

import React from 'react';
import { clsx } from 'clsx';

export interface SectionProps {
  children: React.ReactNode;
  className?: string;
  id?: string;
  background?: 'cream' | 'white' | 'sand' | 'primary';
  padding?: 'sm' | 'md' | 'lg' | 'xl';
}

export const Section: React.FC<SectionProps> = ({
  children,
  className,
  id,
  background = 'white',
  padding = 'lg',
}) => {
  const backgroundStyles = {
    cream: 'bg-cream',
    white: 'bg-white',
    sand: 'bg-sand',
    primary: 'bg-primary-50',
  };

  const paddingStyles = {
    sm: 'py-12',
    md: 'py-16',
    lg: 'py-20',
    xl: 'py-24 md:py-32',
  };

  return (
    <section
      id={id}
      className={clsx(
        'w-full',
        backgroundStyles[background],
        paddingStyles[padding],
        className
      )}
    >
      <div className="container mx-auto px-4 sm:px-6 lg:px-8">
        {children}
      </div>
    </section>
  );
};
